import { APP_VERSION } from "../../utils";
export const Welcome = ({ name, surname, role }) => {
  return (
    <div className="container__pages">
      <h2>
        Bienvenido {name} {surname}
      </h2>
      <div className="container_form">
        <h3>ver {APP_VERSION}</h3>
        <p>Rol : {role}</p>
      </div>
      <br />
    </div>
  );
};
